<template>
  <v-col>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-form ref="form" v-model="valid">
            <v-card-title class="pa-8 pb-2">Topik</v-card-title>
            <div class="px-8 pb-4">
              <v-row>
                <v-col>
                  <div class="font-weight-medium mb-2">Judul Topik</div>
                  <v-text-field
                    outlined
                    placeholder="Masukkan judul topik"
                    v-model="title_topik"
                    required
                    :rules="[...rules('Judul Topik', 'required'), validate]"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <!-- <v-card-actions v-show="simpan" class="background">
              <v-spacer></v-spacer>
              <v-btn color="primary" :loading="submiting" @click="save();">Simpan</v-btn>
            </v-card-actions> -->
          </v-form>
        </v-card>
      </v-col>

      <activity-form
        v-show="aktifitas"
        v-for="(activity, index) in activities"
        :seq="index + 1"
        :key="activity.id"
        :activity="activity"
        :submiting="submiting"
        @click:submit="submit"
        @update:activity="$set(activities, index, $event)"
        @click:cancel="
          $router.push({ name: 'program-detail', params: { id: $route.params.program } })
        "
      ></activity-form>

      <!-- <v-col cols="12">
        <v-row no-gutters justify="space-between">
          <div>
            <v-btn color="primary" outlined @click="create">
              <span><v-icon>$add</v-icon> Tambah aktivitas</span>
            </v-btn>
          </div>
          <div>
            <v-btn
              class="mr-4"
              color="primary"
              outlined
              @click="$router.push({ name: 'program-detail' })"
              >Batal</v-btn
            >
            <v-btn color="primary">Simpan Topik</v-btn>
          </div>
        </v-row>
      </v-col> -->
      <v-snackbar top v-model="snackbar.state" color="primary" outlined :timeout="timeout">
        <div v-html="snackbar.text"></div>
        <template v-slot:action="{ attrs }">
          <v-btn small icon color="error" v-bind="attrs" @click="snackbar.state = false">
            <v-icon>$close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-row>
  </v-col>
</template>

<script>
import ActivityForm from "./ActivityForm";
import validationMixin from "../../_mixins/validation";

export default {
  mixins: [validationMixin],
  components: { ActivityForm },
  data: () => ({
    activities: [],
    aktifitas: true,
    simpan: true,
    title_topik: "",
    submiting: false,
    valid: true,
    errors: null,
    isDisabled: false,
    snackbar: {
      state: false,
      text: "",
    },
    timeout: 5000,
  }),
  computed: {
    validate() {
      return !this.errors || this.errors.message;
    },
  },
  created() {
    this.$emit("page-changed", 1, {
      title: "Topik & Aktifitas",
      link: `/program/${this.$route.params.program}`,
    });
    this.$emit("page-changed", 2, {
      title: "Tambah Topik & Aktivitas",
      link: this.$route.path,
    });
    this.create();
    this.detail();
  },
  methods: {
    async submit(payload) {
      if (payload instanceof Error) {
        console.error(payload);
        let message = payload.message;
        if (payload.response?.data?.message) {
          message = payload.response.data.message;
        }
        this.snackbar.text = `Error: ${message}.`;
        this.snackbar.state = true;
        return;
      }

      this.submiting = true;
      const program = this.$route.params.program;
      const topic = this.$route.params.topic;
      try {
        const data = await this.$store
          .dispatch("activity/create", { program, topic, ...payload })
          .then((res) => res.data);
        this.snackbar.text = `Aktivitas berhasil dibuat.`;
        this.snackbar.state = true;
        setTimeout(() => {
          if (["pre_test", "quiz", "post_test"].includes(data.type)) {
            this.$router.push({
              name: "activity-edit",
              params: { program, topic, id: data.id },
            });
          } else {
            this.$router.push({ name: "program-detail", params: { id: program } });
          }
          this.submiting = false;
        }, 1000);
      } catch (error) {
        let message = error.message;
        if (error.response?.data) {
          message = error.response.data.message;
        }
        this.snackbar.text = `Error: ${message}`;
        this.snackbar.state = true;
        this.submiting = false;
        console.error(error);
      }
    },
    detail() {
      this.axios.get(`/topic/v1/detail/${this.$route.params.topic}`).then((res) => {
        this.title_topik = res.data.data.name;
      });
    },
    create() {
      this.$emit("page-changed", 1, {
        title: "Topik & Aktifitas",
        link: `/program/${this.$route.params.program}`,
      });
      this.$emit("page-changed", 2, {
        title: "Tambah Topik & Aktivitas",
        link: this.$route.path,
      });
      this.activities.push({status: 'publish'});
    },
    onDragStart(e, index) {
      e.dataTransfer.setData("index", index);
    },
    onDrag(e) {
      if (!e.clientY) return;
      if (e.clientY < 100) {
        window.scrollTo({
          top: window.pageYOffset - 100,
          behavior: "smooth",
        });
      }
      if (e.clientY > window.outerHeight - 100) {
        window.scrollTo({
          top: window.pageYOffset + 100,
          behavior: "smooth",
        });
      }
    },
    onDrop(e, position) {
      const index = e.dataTransfer.getData("index");
      const activity = this.activities.splice(index, 1);
      this.activities.splice(position, 0, ...activity);
    },
    save() {
      this.errors = null;
      this.submiting = true;

      setTimeout(() => {
        if (this.$refs.form.validate()) {
          let params = {
            name: this.title_topik,
            status: "draft",
            program_id: this.$route.params.id,
          };
          this.axios
            .post(`topic/v1/create`, params)
            .then(() => {
              this.submiting = false;
              this.snackbar.text = `Topik berhasil ditambahkan`;
              this.snackbar.state = true;
              this.aktifitas = true;
              this.simpan = false;
              this.isDisabled = true;
            })
            .catch((res) => {
              this.submiting = false;
              if (res.response) {
                this.snackbar.text = res.response.data.message;
                this.snackbar.state = true;
              }
            });
        }
      }, 50);
    },
  },
};
</script>
